import FileFill from "~icons/eva/file-fill"
import CloseOutline from "~icons/eva/close-outline"
import styles from "./styles.module.scss"
import classNames from "classnames"

export const NavigatorFileCard = ({
  handleDelete,
  onClick,
  file,
}: {
  handleDelete?: () => void
  onClick?: () => void
  file: { name: string; type: string }
}) => {
  return (
    <div className={styles.fileItemWrapper}>
      <div
        className={classNames(styles.fileItem, onClick && styles.fileItemInteractive)}
        onClick={onClick}
      >
        {handleDelete ? (
          <button className={styles.fileItemCloseButton} type="button" onClick={handleDelete}>
            <CloseOutline />
          </button>
        ) : null}
        <div className={styles.fileIconWrapper}>
          <FileFill />
        </div>
        <div>
          <p className={styles.fileName}>
            {file.name.length > 26 ? `${file.name.slice(0, 22)}...` : file.name}
          </p>
          <p className={styles.fileType}>
            {file.type.replace(/^(image\/|application\/)/, "").toUpperCase()}
          </p>
        </div>
      </div>
    </div>
  )
}
